import { render, staticRenderFns } from "./addItems.vue?vue&type=template&id=84bf8bb2&"
import script from "./addItems.vue?vue&type=script&lang=js&"
export * from "./addItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports